import { render, staticRenderFns } from "./CreateTask.vue?vue&type=template&id=be4ca806&scoped=true"
import script from "./CreateTask.vue?vue&type=script&lang=js"
export * from "./CreateTask.vue?vue&type=script&lang=js"
import style0 from "./CreateTask.vue?vue&type=style&index=0&id=be4ca806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4ca806",
  null
  
)

export default component.exports